
const data = [
  {
    title: '人力资源战略概述',
    description: '人力资源战略是企业人力资源管理的顶层设计，通过细致深入的洞察和内在规律的把握，深刻理解企业未来战略发展对组织的要求，紧贴业务发展对企业人力资源数量、质量及结构进行合理配置，提升企业的发展速度与质量。'
  },
  {
    title: '服务内容',
    description: '企业组织规划与设计\n企业人力需求\n企业人才培养策略设计\n企业绩效管理'
  },
  {
    title: '服务特点',
    description: '始终以业务为生；\n与客户深度融合，一起洞察趋势，借鉴标杆，做出最符合企业需要的人力资源战略。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/hr-strategy.js